/* BaseUserSessionMixin.js */

"use strict";

let mixin = (superKlass) =>
    class BaseUserSessionMixin extends superKlass {
        /**
         * Get the Current Org.
         */
        pmGetCurrentOrg(/*continuation*/) {
            return this._userSession.activeOrganization.name;
        }

        /**
         * Get the current user name.
         */
        pmGetCurrentUserName(/*continuation*/) {
            if (this._userSession.user) {
                return this._userSession.user.userName;
            } else if (this._userSession.info) {
                return this._userSession.info.userName;
            }
        }
    };
module.exports = mixin;
